import { render, staticRenderFns } from "./awards.vue?vue&type=template&id=47bdfb79&scoped=true"
import script from "./awards.vue?vue&type=script&lang=js"
export * from "./awards.vue?vue&type=script&lang=js"
import style0 from "./awards.vue?vue&type=style&index=0&id=47bdfb79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bdfb79",
  null
  
)

export default component.exports